import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showChatBox } from "../../reducers/ChatBox";
var ChatIcon = "/static/icons/chat_icon.svg";
import { isChatAvailable } from "./chatConfig";
import { ChatButton, ChatButtonText } from "./style";
var ChatBoxButton = /*#__PURE__*/function (_Component) {
  function ChatBoxButton() {
    var _this;
    _classCallCheck(this, ChatBoxButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, ChatBoxButton, [].concat(args)), _this.handleChatClick = function () {
      var showChat = isChatAvailable();
      showChat && _this.props.chatPrompt();
    }, _assertThisInitialized(_this)));
  }
  _inherits(ChatBoxButton, _Component);
  return _createClass(ChatBoxButton, [{
    key: "render",
    value: function render() {
      var showChat = isChatAvailable();
      if (showChat) {
        return __jsx(ChatButton, {
          onClick: this.handleChatClick,
          tabIndex: "0",
          role: "button",
          "aria-pressed": "false",
          onKeyPress: this.handleChatClick
        }, __jsx("span", null, __jsx("img", {
          src: ChatIcon,
          alt: "chat-icon"
        })), __jsx(ChatButtonText, null, "Chat"));
      }
      return __jsx(ChatButton, null);
    }
  }]);
}(Component);
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    chatPrompt: function chatPrompt() {
      dispatch(showChatBox());
    }
  };
};
ChatBoxButton.defaultProps = {
  chatPrompt: function chatPrompt() {}
};
export default connect(null, mapDispatchToProps)(ChatBoxButton);